import { digitsToEasternArabic } from '@/lib/plate';

interface PlateBadgeProps {
  plate: string | null | undefined;
  plateAr?: string | null;
  className?: string;
  /** Render Arabic digits in the AR caption (visual only) */
  arabicDigits?: boolean;
}

/**
 * Canonical Saudi plate display. Storage format is "NNNN-LLL" (PR MAY10 P1.2).
 * Renders the EN plate in monospace LTR with an optional AR caption underneath.
 */
export function PlateBadge({ plate, plateAr, className, arabicDigits = true }: PlateBadgeProps) {
  if (!plate) return <span className="text-muted-foreground">—</span>;

  const arDisplay = (() => {
    if (!plateAr) return null;
    if (!arabicDigits) return plateAr;
    const m = plateAr.match(/^([0-9]+)([-\s]?)(.+)$/);
    if (!m) return plateAr;
    return `${digitsToEasternArabic(m[1])}${m[2]}${m[3]}`;
  })();

  return (
    <div className={className}>
      <div className="font-mono font-medium tabular-nums text-foreground" dir="ltr">{plate}</div>
      {arDisplay && (
        <div className="text-xs text-muted-foreground font-mono" dir="rtl">{arDisplay}</div>
      )}
    </div>
  );
}
